import { createSelector } from 'reselect'

export const searchTermSelector = state => state.application.searchTerm
export const pageTypeSelector = state => state.application.pageType

const userDetailsSelector = state => state.userDetails
export const userStateSelector = createSelector(userDetailsSelector, userDetails => {
  return userDetails && userDetails.data ? userDetails.data.userState : ''
})
